"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationHandle = exports.OrganizationPrivateHandle = exports.EnterpriseHandleMapping = exports.EnterpriseHandle = exports.OrganizationPublicHandle = exports.UserHandle = void 0;
exports.isHandleMappingForUser = isHandleMappingForUser;
exports.isHandleMappingForOrganization = isHandleMappingForOrganization;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const identifier_1 = require("./identifier");
/**
 * A user handle is a unique string, chosen by the user, that acts as the main username
 *
 * The username appears in the path to the user document, and also as the "handle" property on the IUserData. It also
 * appears as the key on the separate usernames collection (used for reserving usernames, see the HandleRepository)
 *
 * aspirational: brand this as a zod string one day?
 */
exports.UserHandle = zod_1.default.string().min(3);
/**
 * An organization handle is a unique string, chosen by the user, that acts as the main username of the organization
 *
 * The username appears in the path to the organization document, and also as the "handle" property on the Organization. It also
 * appears as the key on the separate usernames collection (used for reserving usernames, see the HandleRepository)
 */
exports.OrganizationPublicHandle = zod_1.default.string().brand("OrganizationPublicHandle");
function isHandleMappingForUser(data) {
    return (typeof data === "object" &&
        !!data &&
        !!data?.userHandle &&
        !!data?.user_uid &&
        !data?.organizationUid);
}
function isHandleMappingForOrganization(data) {
    return (typeof data === "object" &&
        !!data &&
        !!data?.userHandle &&
        !!data?.organizationUid &&
        !data?.user_uid);
}
/**
 * An enterprise handle follows the same rules as a user/organization handle, but forms a separate unique namespace
 */
exports.EnterpriseHandle = zod_1.default
    .string()
    .min(3)
    .regex(/[a-z][-a-z0-9]{2,}/)
    .brand("EnterpriseHandle");
/**
 * Enterprise handles need to be unique across all enterprises, and this mapping entry ensures that is the case.
 *
 * It is stored keyed by the enterprise handle, and contains the enterprise UID that owns the handle. Because
 * we don't yet support self-signup for enterprises (because it may give away existing enterprise handles via
 * form validation), these entries are usually created by an admin backend process
 */
exports.EnterpriseHandleMapping = zod_1.default.object({
    handle: exports.EnterpriseHandle,
    enterpriseUid: identifier_1.EnterpriseUid,
});
/**
 * An enterprise handle follows the same rules as a user/organization handle, but forms a separate unique namespace
 */
exports.OrganizationPrivateHandle = zod_1.default
    .string()
    .min(3)
    .regex(/[a-z][-a-z0-9]{2,}/)
    .brand("OrganizationPrivateHandle");
exports.OrganizationHandle = exports.OrganizationPrivateHandle;
//# sourceMappingURL=handle.js.map